import { render, staticRenderFns } from "./vsTr.vue?vue&type=template&id=4a828419&"
import script from "./vsTr.vue?vue&type=script&lang=js&"
export * from "./vsTr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsTr.vue"
export default component.exports